/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const root = (typeof window !== "undefined") ? window : globalThis;

root.initChooseXWithOpen = function() {
  const event = function() {
    const t = $(this);
    const checkbox = t.parent().prev().find(":checkbox, :radio").last();
    return checkbox.get(0).checked = !!t.val();
  };
  const textareas = $(`.survey-slider .choose-one + .user_response_question_response_text textarea, \
.survey-slider .choose-multiple + .user_response_question_response_text textarea, \
.survey-slider .choose-one + .user_response_question_response_text input, \
.survey-slider .choose-multiple + .user_response_question_response_text input`);
  textareas.keyup(event);
  textareas.change(event);

  textareas.each((n, t) => $(t).parent().prev().find(":checkbox, :radio").last().data("open_question", true).click(function() {
    const i = $(this);
    return i.parent().parent().parent().next().find("textarea, input").focus();
  }));

  return textareas.parent().prev().find(":radio").last().prop("open_question", true);
};

/*
$(() => initChooseXWithOpen());
*/

function initSurveyOnLoad() {
  if ($('.survey-slider').length) {
    initChooseXWithOpen();
  }
}

$(initSurveyOnLoad);
document.addEventListener('turbo:load', initSurveyOnLoad);

